// extracted by mini-css-extract-plugin
module.exports = {"container":"products_container__w2QsA","products":"products_products__1b98G"};
module.exports.__checksum = "bdecad98d16b"
